import {createSlice} from "@reduxjs/toolkit"

/**
 * an array of video Note objects. The Video note object is defined as:
 *
 * 	heading: Title of the video that is displayed in the "tree". Equivalent to {Note.content}.
 * 	content: placeholder for future text content that could appear above or below the video.
 * 	videoUrl: the raw URL to the YouTube video.
 * 	videoId: the ID of the YouTube video, consumed by the iFrame element
 * 	open: is the "Note" open or closed?
 * @type {Array<{heading: string, content: string, videoUrl: string, videoId: string, open: boolean}>}
 */
const instructionsTree = [
	{
		heading: "Introduction & Layout",
		content: "lorem",
		videoUrl: "https://youtu.be/k0Nuj5YvSGY",
		videoId: "k0Nuj5YvSGY",
		open: false
	},
	{
		heading:"Navigation",
		content: "lorem",
		videoUrl: "https://youtu.be/WqrJ__2c9iE",
		videoId: "WqrJ__2c9iE",
		open: false,
	},
	{
		heading: "Automatic ordering of notes",
		content: "lorem",
		videoUrl: "https://youtu.be/MhXLM7_JVtA",
		videoId: "MhXLM7_JVtA",
		open: false,
	},
	{
		heading: "Linking articles to notes",
		content: "lorem",
		videoUrl: "https://youtu.be/ot0QGpk2TTM",
		videoId: "ot0QGpk2TTM",
		open: false,
	},
	{
		heading: "Uploading Full Text PDFs",
		content: "lorem",
		videoUrl: "https://youtu.be/8DC4CUhZyww",
		videoId: "8DC4CUhZyww",
		open: false
	},
	{
		heading:"Adding articles to notes",
		content: "lorem",
		videoUrl: "https://youtu.be/Vb5T57yKkzs",
		videoId: "Vb5T57yKkzs",
		open: false,
	},
	{
		heading:"Importing citations",
		content: "lorem",
		videoUrl: "https://youtu.be/aw9EL9hqNxI",
		videoId: "aw9EL9hqNxI",
		open: false,
	},
	{
		heading: "Working with notes",
		content: "lorem",
		videoUrl: "https://youtu.be/cBuDRpuaFDc",
		videoId: "cBuDRpuaFDc",
		open: false,
	},

]

export const instructionVidsSlice = createSlice({
	name: "instructionVids",
	initialState: {
		instructions: instructionsTree
	},
	reducers: {
		closeAllInstructions: (state) => {
			state.instructions = instructionsTree
		},
		openInstruction: (state, action) => {
			const vidToOpen = state.instructions[action.payload]
			vidToOpen.open = true
			state.instructions[action.payload] = vidToOpen
		},
		closeInstruction: (state, action) => {
			const vidToOpen = state.instructions[action.payload]
			vidToOpen.open = false
			state.instructions[action.payload] = vidToOpen
		}
	}
})

export const {openInstruction, closeInstruction, closeAllInstructions} = instructionVidsSlice.actions

export const selectAllInstructions = (state) => state.instructionVids.instructions

export default instructionVidsSlice.reducer